import {
  amber,
  blueGrey,
  deepOrange,
  deepPurple,
  indigo,
  lightGreen,
  teal,
} from "@mui/material/colors";

/**
 * Array of colors used for charts.
 *
 * @type {Array<string>}
 */
export const ChartColors = [
  teal[500],
  deepOrange[500],
  indigo[500],
  lightGreen[500],
  deepPurple[500],
  amber[500],
  blueGrey[500],
];

/**
 * Generates a distinct HSL color by rotating the hue across `total` slots.
 * Used for charts with a dynamic number of series.
 */
export function generateHslColor(
  index: number,
  total: number,
  lightness = 55
): string {
  const hue = Math.round((360 / total) * index);
  return `hsl(${hue}, 65%, ${lightness}%)`;
}
